import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../Context/LanguageContext";
import "./Members.css";


const MEMBERS_API_URL =
    "https://script.google.com/macros/s/AKfycbw3zL12yxAeHhFubKpPNm2DXIeINp7_RZYPij4oKjiBzRUuY6aVEFFUCdBQugIeUsMljg/exec";


function Members() {

    const { language } = useLanguage();

    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [search, setSearch] = useState("");
    const [searchResult, setSearchResult] = useState(null);
    const [searched, setSearched] = useState(false);


    /* =====================================================
       LOAD MEMBERS
    ===================================================== */

    useEffect(() => {

        getMembers();

    }, []);


    function getMembers() {

        fetch(MEMBERS_API_URL)

            .then((response) => {

                if (!response.ok) {
                    throw new Error(
                        "Unable to load member information."
                    );
                }

                return response.json();

            })

            .then((data) => {

                const names =
                    data.names || [];

                const ids =
                    data.ids || [];


                const combinedMembers =
                    names.map((name, index) => ({
                        name: name,
                        id: ids[index] || ""
                    }));


                setMembers(combinedMembers);
                setLoading(false);

            })

            .catch((error) => {

                console.error(error);

                setError(error.message);
                setLoading(false);

            });

    }


    /* =====================================================
       SEARCH
    ===================================================== */

    function handleSearch(e) {

        e.preventDefault();


        const searchValue =
            search
                .trim()
                .toLowerCase();


        if (!searchValue) {

            setSearched(false);
            setSearchResult(null);

            return;

        }


        const foundMember =
            members.find((member) => {

                const memberId =
                    String(member.id || "")
                        .trim()
                        .toLowerCase();

                const memberName =
                    String(member.name || "")
                        .trim()
                        .toLowerCase();


                return (
                    memberId === searchValue ||
                    memberName === searchValue
                );

            });


        setSearchResult(
            foundMember || null
        );

        setSearched(true);

    }


    function handleInputChange(e) {

        setSearch(
            e.target.value
        );


        if (searched) {

            setSearched(false);
            setSearchResult(null);

        }

    }


    return (

        <main className="members-page">


            {/* =========================================
                HERO
            ========================================= */}

            <section className="members-hero">

                <div className="container members-hero-content">

                    <span className="members-hero-label">

                        {language === "bn"
                            ? "আমাদের সদস্য"
                            : "Our Members"}

                    </span>


                    <h1>

                        {language === "bn"
                            ? "সদস্য যাচাই করুন"
                            : "Verify Membership"}

                    </h1>


                    <p>

                        {language === "bn"
                            ? "আমরা-আমরার সদস্য তালিকায় আপনার সদস্যপদ আছে কিনা নাম অথবা Member ID দিয়ে যাচাই করুন।"
                            : "Check whether you are an Amra-Amra member using your full name or Member ID."}

                    </p>

                </div>

            </section>


            {/* =========================================
                CONTENT
            ========================================= */}

            <section className="members-content">

                <div className="container">


                    {/* =====================================
                        SEARCH CARD
                    ===================================== */}

                    <div className="member-search-card">


                        <div className="member-search-heading">

                            <span className="member-search-icon">
                                ✓
                            </span>


                            <div>

                                <h2>

                                    {language === "bn"
                                        ? "সদস্য খুঁজুন"
                                        : "Find a Member"}

                                </h2>


                                <p>

                                    {language === "bn"
                                        ? "আপনার Member ID অথবা পুরো নাম লিখুন।"
                                        : "Enter your Member ID or full name."}

                                </p>

                            </div>

                        </div>


                        {/* =================================
                            LOADING
                        ================================= */}

                        {loading && (

                            <div className="member-message">

                                <div className="member-loader"></div>

                                <span>

                                    {language === "bn"
                                        ? "সদস্যদের তথ্য লোড হচ্ছে..."
                                        : "Loading member information..."}

                                </span>

                            </div>

                        )}


                        {/* =================================
                            ERROR
                        ================================= */}

                        {!loading && error && (

                            <div className="member-error">

                                <strong>

                                    {language === "bn"
                                        ? "তথ্য লোড করা যায়নি"
                                        : "Unable to load member information"}

                                </strong>

                                <span>
                                    {error}
                                </span>

                            </div>

                        )}


                        {/* =================================
                            SEARCH FORM
                        ================================= */}

                        {!loading && !error && (

                            <form
                                className="member-search-form"
                                onSubmit={handleSearch}
                            >

                                <div className="member-search-field">

                                    <label htmlFor="memberSearch">

                                        {language === "bn"
                                            ? "Member ID / নাম"
                                            : "Member ID / Name"}

                                    </label>


                                    <div className="member-search-input">

                                        <span>
                                            ⌕
                                        </span>


                                        <input
                                            id="memberSearch"
                                            type="text"
                                            value={search}
                                            onChange={handleInputChange}
                                            placeholder={
                                                language === "bn"
                                                    ? "যেমন: M101 অথবা Adil Mahmud"
                                                    : "Example: M101 or Adil Mahmud"
                                            }
                                            autoComplete="off"
                                        />

                                    </div>

                                </div>


                                <button
                                    type="submit"
                                    className="member-search-button"
                                >

                                    {language === "bn"
                                        ? "সদস্য খুঁজুন"
                                        : "Search Member"}

                                    <span>
                                        →
                                    </span>

                                </button>

                            </form>

                        )}


                        {/* =================================
                            MEMBER FOUND
                        ================================= */}

                        {!loading &&
                            !error &&
                            searched &&
                            searchResult && (

                                <div className="member-result member-found">


                                    <div className="member-result-icon">
                                        ✓
                                    </div>


                                    <div className="member-result-content">

                                        <span className="member-result-label">

                                            {language === "bn"
                                                ? "সদস্য পাওয়া গেছে"
                                                : "Member Found"}

                                        </span>


                                        <h3>
                                            {searchResult.name}
                                        </h3>


                                        <div className="member-result-id">

                                            <span>
                                                Member ID
                                            </span>

                                            <strong>
                                                {searchResult.id}
                                            </strong>

                                        </div>

                                    </div>

                                </div>

                            )}


                        {/* =================================
                            MEMBER NOT FOUND
                        ================================= */}

                        {!loading &&
                            !error &&
                            searched &&
                            !searchResult && (

                                <div className="member-result member-not-found">


                                    <div className="member-result-icon">
                                        !
                                    </div>


                                    <div className="member-result-content">

                                        <span className="member-result-label">

                                            {language === "bn"
                                                ? "সদস্য পাওয়া যায়নি"
                                                : "Member Not Found"}

                                        </span>


                                        <h3>

                                            {language === "bn"
                                                ? "কোনো সদস্য মেলেনি"
                                                : "No matching member found"}

                                        </h3>


                                        <p>

                                            {language === "bn"
                                                ? "Member ID অথবা নামটি সঠিকভাবে লিখে আবার চেষ্টা করুন।"
                                                : "Please check the Member ID or full name and try again."}

                                        </p>

                                    </div>

                                </div>

                            )}

                    </div>


                    {/* =====================================
                        REGISTRATION CTA
                    ===================================== */}

                    <div className="member-register-card">


                        <div>

                            <span>

                                {language === "bn"
                                    ? "আমাদের সাথে যুক্ত হোন"
                                    : "Join Our Community"}

                            </span>


                            <h2>

                                {language === "bn"
                                    ? "আমরা-আমরার সদস্য হতে চান?"
                                    : "Want to become an Amra-Amra member?"}

                            </h2>


                            <p>

                                {language === "bn"
                                    ? "আমাদের কমিউনিটিতে যুক্ত হয়ে অনুষ্ঠান, সংস্কৃতি এবং সামাজিক কার্যক্রমে অংশ নিন।"
                                    : "Join our community and take part in events, cultural programs and social activities."}

                            </p>

                        </div>


                        <Link
                            to="/registermember"
                            className="member-register-button"
                        >

                            {language === "bn"
                                ? "সদস্য হিসেবে নিবন্ধন করুন"
                                : "Register as a Member"}

                            <span>
                                →
                            </span>

                        </Link>

                    </div>

                </div>

            </section>

        </main>

    );

}


export default Members;